import {useHistory} from "react-router-dom";
import {useSelector} from "react-redux";
import {Routes} from "../../../routes";
import Competitor from "../../components/Demand/Competitor";
import React from "react";
import Mercado from "../../components/Demand/Mercado";

function MercadoPage() {
    const navigate = useHistory();
    const ciemId = useSelector(state => state.ciem.ciemId);
    if(!ciemId){
        alert("Para ingresar a esta opcion debe seleccionar una idea de negocio");
        //console.log("no tiene ciem")
        navigate.push(Routes.ListCiemPage.path);
    }
    return (
        <div>
            <Mercado ciemId={ciemId}/>
        </div>
    );
}

export default MercadoPage;